import * as ko from 'knockout';
import { NflGame } from './models/game';
import { NflWeek } from './models/week';

export function GetSchedule(
  teams: TeamDictionary,
  games: IGameData[],
  maxWeek: number
): WeekDictionary {
  var dict: WeekDictionary = {},
    week: NflWeek;
  for (var i = 1; i <= maxWeek; i++) {
    dict[i] = new Array<NflWeek>();
    week = new NflWeek('AFC');
    dict[i].push(week);
    week = new NflWeek('AFC vs. NFC');
    dict[i].push(week);
    week = new NflWeek('NFC');
    dict[i].push(week);
  }

  for (var _gameInt in games) {
    var game = games[_gameInt];
    if (game.Away.Conference == game.Home.Conference) {
      if (game.Away.Conference == 'AFC') {
        dict[game.Week][0].games.push(
          ko.observable(
            new NflGame(
              teams[game.Home.Conference][game.Home.Division][game.Home.TeamAbbreviation],
              teams[game.Away.Conference][game.Away.Division][game.Away.TeamAbbreviation],
              game.Week,
              game.GameTypeID,
              game.GameDate,
              game.GameKey,
              game.GameGUID,
              game.GameScheduleNum
            )
          )
        );
      } else {
        dict[game.Week][2].games.push(
          ko.observable(
            new NflGame(
              teams[game.Home.Conference][game.Home.Division][game.Home.TeamAbbreviation],
              teams[game.Away.Conference][game.Away.Division][game.Away.TeamAbbreviation],
              game.Week,
              game.GameTypeID,
              game.GameDate,
              game.GameKey,
              game.GameGUID,
              game.GameScheduleNum
            )
          )
        );
      }
    } else {
      dict[game.Week][1].games.push(
        ko.observable(
          new NflGame(
            teams[game.Home.Conference][game.Home.Division][game.Home.TeamAbbreviation],
            teams[game.Away.Conference][game.Away.Division][game.Away.TeamAbbreviation],
            game.Week,
            game.GameTypeID,
            game.GameDate,
            game.GameKey,
            game.GameGUID,
            game.GameScheduleNum
          )
        )
      );
    }
  }

  //WC
  dict[maxWeek + 1] = new Array<NflWeek>();
  week = new NflWeek('AFC');
  dict[maxWeek + 1].push(week);
  week = new NflWeek('AFC vs NFC');
  dict[maxWeek + 1].push(week);
  week = new NflWeek('NFC');
  dict[maxWeek + 1].push(week);
  //DV
  dict[maxWeek + 2] = new Array<NflWeek>();
  week = new NflWeek('AFC');
  dict[maxWeek + 2].push(week);
  week = new NflWeek('AFC vs NFC');
  dict[maxWeek + 2].push(week);
  week = new NflWeek('NFC');
  dict[maxWeek + 2].push(week);
  //CG
  dict[maxWeek + 3] = new Array<NflWeek>();
  week = new NflWeek('AFC');
  dict[maxWeek + 3].push(week);
  week = new NflWeek('AFC vs NFC');
  dict[maxWeek + 3].push(week);
  week = new NflWeek('NFC');
  dict[maxWeek + 3].push(week);
  //SB
  dict[maxWeek + 4] = new Array<NflWeek>();
  week = new NflWeek('AFC');
  dict[maxWeek + 4].push(week);
  week = new NflWeek('AFC vs NFC');
  dict[maxWeek + 4].push(week);
  week = new NflWeek('NFC');
  dict[maxWeek + 4].push(week);
  return dict;
}

export function GetScheduleV2(
  teamConfDic: TeamDictionary,
  games: IGameDataV2[],
  maxWeek: number,
  teams: ITeamDataV2[]
): WeekDictionary {
  var dict: WeekDictionary = {},
    week: NflWeek;
  var teamDict: Record<number, ITeamDataV2> = {};
  teams.map((team: ITeamDataV2) => {
    teamDict[team.teamId] = team;
  });
  for (var i = 1; i <= maxWeek; i++) {
    dict[i] = new Array<NflWeek>();
    week = new NflWeek('AFC');
    dict[i].push(week);
    week = new NflWeek('AFC vs. NFC');
    dict[i].push(week);
    week = new NflWeek('NFC');
    dict[i].push(week);
  }
  for (let game of games) {
    let home = teamDict[game.homeId];
    let away = teamDict[game.awayId];
    if (away.conference == home.conference) {
      if (away.conference == 'AFC') {
        dict[game.week][0].games.push(
          ko.observable(
            new NflGame(
              teamConfDic[home.conference][home.division][home.teamAbbreviation],
              teamConfDic[away.conference][away.division][away.teamAbbreviation],
              game.week,
              0,
              game.gameDate,
              game.gameKey,
              game.gameGuid,
              game.gameScheduleNum
            )
          )
        );
      } else {
        dict[game.week][2].games.push(
          ko.observable(
            new NflGame(
              teamConfDic[home.conference][home.division][home.teamAbbreviation],
              teamConfDic[away.conference][away.division][away.teamAbbreviation],
              game.week,
              0,
              game.gameDate,
              game.gameKey,
              game.gameGuid,
              game.gameScheduleNum
            )
          )
        );
      }
    } else {
      dict[game.week][1].games.push(
        ko.observable(
          new NflGame(
            teamConfDic[home.conference][home.division][home.teamAbbreviation],
            teamConfDic[away.conference][away.division][away.teamAbbreviation],
            game.week,
            0,
            game.gameDate,
            game.gameKey,
            game.gameGuid,
            game.gameScheduleNum
          )
        )
      );
    }
  }

  //WC
  dict[maxWeek + 1] = new Array<NflWeek>();
  week = new NflWeek('AFC');
  dict[maxWeek + 1].push(week);
  week = new NflWeek('AFC vs NFC');
  dict[maxWeek + 1].push(week);
  week = new NflWeek('NFC');
  dict[maxWeek + 1].push(week);
  //DV
  dict[maxWeek + 2] = new Array<NflWeek>();
  week = new NflWeek('AFC');
  dict[maxWeek + 2].push(week);
  week = new NflWeek('AFC vs NFC');
  dict[maxWeek + 2].push(week);
  week = new NflWeek('NFC');
  dict[maxWeek + 2].push(week);
  //CG
  dict[maxWeek + 3] = new Array<NflWeek>();
  week = new NflWeek('AFC');
  dict[maxWeek + 3].push(week);
  week = new NflWeek('AFC vs NFC');
  dict[maxWeek + 3].push(week);
  week = new NflWeek('NFC');
  dict[maxWeek + 3].push(week);
  //SB
  dict[maxWeek + 4] = new Array<NflWeek>();
  week = new NflWeek('AFC');
  dict[maxWeek + 4].push(week);
  week = new NflWeek('AFC vs NFC');
  dict[maxWeek + 4].push(week);
  week = new NflWeek('NFC');
  dict[maxWeek + 4].push(week);
  return dict;
}
